/**
 * @desc 参数监控查询
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.ParamMonitorPageRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.ParamMonitorListResponse>>> {
  return defHttp.post({
    url: '/web/ParamManage/qryParamMonitor',
    data,
  });
}

export function mock(
  data: defs.ParamMonitorPageRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.ParamMonitorListResponse>>> {
  return defHttp.post({
    url: '/mock/web/ParamManage/qryParamMonitor',
    data,
  });
}
